import { render, staticRenderFns } from "./video.vue?vue&type=template&id=3f0bb326&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./video.vue?vue&type=style&index=1&id=3f0bb326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bb326",
  null
  
)

export default component.exports